// extracted by mini-css-extract-plugin
export default {"resetButton":"U_LSqVy","root":"C42RWNW","title":"gZwenrG","close":"NQXndGk"};